import React, { useState, useEffect, KeyboardEvent } from 'react';

import { Dropdown, DropdownToggle, DropdownMenu } from 'reactstrap';
import { TopicPairContentType, topicPairContentTypeToString } from '../../../nlp/~store/models/enums/TopicPairContentType';

import './ChooseMessageContentType.css';

export interface chooseMessageContentTypeDialogProps {
    operatorMessageContentType: TopicPairContentType;
    onMessageContentTypeChoosen(contentType: TopicPairContentType): void;
}

export default function ChooseMessageContentTypeDialog(props: chooseMessageContentTypeDialogProps) {
    const [isMenuVisible, setIsMenuVisible] = useState<boolean>(false);
    const [messageContentType, setMessageContentType] = useState<TopicPairContentType>(TopicPairContentType.Text);

    useEffect(() => {
        return setMessageContentType(props.operatorMessageContentType);
    }, [props.operatorMessageContentType])

    useEffect(() => {
        return setMessageContentType(props.operatorMessageContentType);
    }, [props.operatorMessageContentType])

    const _getMaterialUiIcon = (): string => {
        switch (messageContentType) {
            case TopicPairContentType.Markup:
                return 'code';
            case TopicPairContentType.Text:
                return 'text_format';
            case TopicPairContentType.Audio:
                return 'audiotrack';            
            case TopicPairContentType.Video:
                return 'ondemand_video';
            case TopicPairContentType.Navigation:
                return 'arrow_forward';
            case TopicPairContentType.TextToSpeech:
                return 'graphic_eq';
            case TopicPairContentType.Iframe:
                return 'web';
            default:
                return 'text_format';
        }
    }

    const selectMenuItem = (type: TopicPairContentType, keyboardEvent?: KeyboardEvent<HTMLDivElement>) => {
        if (!keyboardEvent || keyboardEvent.key === "Enter") {
            setMessageContentType(type);
            props.onMessageContentTypeChoosen(type);
            setIsMenuVisible(false);
        }
    }

    const _getDropdownMenuItems = (): React.JSX.Element => {
        return (
            <DropdownMenu
                style={{}}
                className="choose-message-content-type-dialog__menu"
            >
                <div
                    className="choose-message-content-type__menu-item"
                    onClick={() => selectMenuItem(TopicPairContentType.Markup)}
                    onKeyUp={(e) => selectMenuItem(TopicPairContentType.Markup, e)}
                    tabIndex={0}
                >
                    <i className="material-icons choose-message-content-type-dialog__dropdown-image">
                        code
                    </i>
                    {topicPairContentTypeToString(TopicPairContentType.Markup)}
                </div>
                <div
                    className="choose-message-content-type__menu-item"
                    onClick={() => selectMenuItem(TopicPairContentType.Text)}
                    onKeyUp={(e) => selectMenuItem(TopicPairContentType.Text, e)}
                    tabIndex={0}
                >
                    <i className="material-icons choose-message-content-type-dialog__dropdown-image">
                        text_format
                    </i>
                    {topicPairContentTypeToString(TopicPairContentType.Text)}
                </div>
                <div
                    className="choose-message-content-type__menu-item"
                    onClick={() => selectMenuItem(TopicPairContentType.Video)}
                    onKeyUp={(e) => selectMenuItem(TopicPairContentType.Video, e)}
                    tabIndex={0}
                >
                    <i className="material-icons choose-message-content-type-dialog__dropdown-image">
                        ondemand_video
                    </i>
                    {topicPairContentTypeToString(TopicPairContentType.Video)}
                </div>
                <div
                    className="choose-message-content-type__menu-item"
                    onClick={() => selectMenuItem(TopicPairContentType.Audio)}
                    onKeyUp={(e) => selectMenuItem(TopicPairContentType.Audio, e)}
                    tabIndex={0}
                >
                    <i className="material-icons choose-message-content-type-dialog__dropdown-image">
                        audiotrack
                    </i>
                    {topicPairContentTypeToString(TopicPairContentType.Audio)}
                </div>
                <div
                    className="choose-message-content-type__menu-item"
                    onClick={() =>
                        selectMenuItem(TopicPairContentType.Navigation)
                    }
                    onKeyUp={(e) =>
                        selectMenuItem(TopicPairContentType.Navigation, e)
                    }
                    tabIndex={0}
                >
                    <i className="material-icons choose-message-content-type-dialog__dropdown-image">
                        arrow_forward
                    </i>
                    {topicPairContentTypeToString(
                        TopicPairContentType.Navigation
                    )}
                </div>
                <div
                    className="choose-message-content-type__menu-item"
                    onClick={() =>
                        selectMenuItem(TopicPairContentType.TextToSpeech)
                    }
                    onKeyUp={(e) =>
                        selectMenuItem(TopicPairContentType.TextToSpeech, e)
                    }
                    tabIndex={0}
                >
                    <i className="material-icons choose-message-content-type-dialog__dropdown-image">
                        graphic_eq
                    </i>
                    {topicPairContentTypeToString(
                        TopicPairContentType.TextToSpeech
                    )}
                </div>
                <div
                    className="choose-message-content-type__menu-item"
                    onClick={() => selectMenuItem(TopicPairContentType.Iframe)}
                    onKeyUp={(e) => selectMenuItem(TopicPairContentType.Iframe, e)}
                    tabIndex={0}
                >
                    <i className="material-icons choose-message-content-type-dialog__dropdown-image">
                        web
                    </i>
                    {topicPairContentTypeToString(TopicPairContentType.Iframe)}
                </div>
            </DropdownMenu>
        );
    }

    const handelDialogKeyUp = (e: KeyboardEvent<HTMLElement>) => {
        if (e.key === "Enter") {
            setIsMenuVisible(true);
        }
    };

    return (
        <React.Fragment>
            <Dropdown direction="up" className="choose-message-content-type-dialog__container" isOpen={isMenuVisible} toggle={() => {setIsMenuVisible(!isMenuVisible)}}>
                <DropdownToggle tag="div">
                    <i
                        tabIndex={0}
                        onKeyDown={handelDialogKeyUp}
                        className="material-icons choose-message-content-type-dialog__image">
                        {_getMaterialUiIcon()}
                    </i>
                    {isMenuVisible && _getDropdownMenuItems()}                        
                </DropdownToggle>
            </Dropdown>
        </React.Fragment>
    )
}